import { SearchField } from '@amzn/meridian';
import { type FC, useCallback, useState } from 'react';

export type FilterSearchInputProps = {
  id: string;
  addSearchQuery: (input: string) => void;
};

export const FilterSearchInput: FC<FilterSearchInputProps> = ({ id, addSearchQuery }) => {
  const [searchInput, setSearchInput] = useState('');

  const handleSubmit = useCallback(() => {
    addSearchQuery(searchInput.toLowerCase());
    setSearchInput('');
  }, [
    addSearchQuery,
    searchInput,
  ]);

  return (
    <SearchField
      aria-label="Search"
      autoComplete="off"
      data-cy="filter-search-input"
      id={id}
      onChange={setSearchInput}
      onSubmit={handleSubmit}
      placeholder="Search by name"
      searchButton
      size="small"
      value={searchInput}
    />
  );
};
